import { render, staticRenderFns } from "./ProjTask.vue?vue&type=template&id=1fc4dcda&scoped=true"
import script from "./ProjTask.vue?vue&type=script&lang=js"
export * from "./ProjTask.vue?vue&type=script&lang=js"
import style0 from "./ProjTask.vue?vue&type=style&index=0&id=1fc4dcda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4dcda",
  null
  
)

export default component.exports